import { dateListOffer } from "@/lib/Types/DateListResponse/DateListResponse";

/**
 * Detects known fields in a datelist offer that, when missing/null,
 * crash the OfferListItem render. Used by the error boundary in debug
 * mode to show the human-readable cause.
 */
export function getOfferIssues(offer: dateListOffer): string[] {
  const issues: string[] = [];

  if (offer.flights) {
    if (
      !Array.isArray(offer.flights.outwardFlight) ||
      offer.flights.outwardFlight.length === 0
    ) {
      issues.push("flights.outwardFlight is missing or empty");
    } else {
      offer.flights.outwardFlight.forEach((flight, i) => {
        if (flight?.departure?.datetime == null) {
          issues.push(`flights.outwardFlight[${i}].departure.datetime is null`);
        }
        if (flight?.destination?.datetime == null) {
          issues.push(
            `flights.outwardFlight[${i}].destination.datetime is null`
          );
        }
      });
    }

    if (
      !Array.isArray(offer.flights.returnFlight) ||
      offer.flights.returnFlight.length === 0
    ) {
      issues.push("flights.returnFlight is missing or empty");
    } else {
      offer.flights.returnFlight.forEach((flight, i) => {
        if (flight?.departure?.datetime == null) {
          issues.push(`flights.returnFlight[${i}].departure.datetime is null`);
        }
        if (flight?.destination?.datetime == null) {
          issues.push(
            `flights.returnFlight[${i}].destination.datetime is null`
          );
        }
      });
    }
  }

  if (Array.isArray(offer.offerRoomDetails)) {
    offer.offerRoomDetails.forEach((room, i) => {
      if (room.nameOffer == null) {
        issues.push(`offerRoomDetails[${i}].nameOffer is null`);
      }
    });
  }

  return issues;
}
